export function ModuleTitle({ children, testId, as: Tag = "h2", className = "" }) {
  return (
    <Tag
      data-testid={testId}
      className={`patria-module-title text-sm sm:text-base ${className}`}
    >
      {children}
    </Tag>
  );
}
